import { render, staticRenderFns } from "./addPartner.vue?vue&type=template&id=6829a82c&"
import script from "./addPartner.vue?vue&type=script&lang=js&"
export * from "./addPartner.vue?vue&type=script&lang=js&"
import style0 from "./addPartner.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports